



























































	import { Component,Vue,Prop } from 'vue-property-decorator'

	@Component
	export default class ImportBranch extends Vue{
        @Prop({
            type: Array,
            default: []
        })
		list:any
		@Prop({
            type: Object,
            default: null
        })
		pager:any
		@Prop({
            type: Array,
            default: []
        })
		column:any
		@Prop({
            type: String,
            default: 'selection'
        })
		type:any
		@Prop({
            type: Boolean,
            default: false
        })
		selection:any
		@Prop({
            type: Boolean,
            default: false
        })
		border:any
		@Prop({
            type: Boolean,
            default: false
        })
		showSummary:any
		@Prop({
            type: String,
            default: '500px'
        })
		height:any
		@Prop({
            type: Boolean,
            default: false
        })
		dbl:any

		multipleSelection = []
		handleSelectionChange(val:any) {
			this.multipleSelection = val;
			this.$emit('multiplechange',val)
		}
		clear(){
			this.multipleSelection = [];
		}
		tableRowClassName ({row, rowIndex}:any) {
	       //把每一行的索引放进row
	       row.index = rowIndex;
	    }
		pagechange(page:any){
			this.$emit('pagechange',[{ key: 'page', val: page }])
		}
		dblClickRow(row:any, column:any, cell:any, event:any){
			this.list[row.index][column.property].dblStatus = true
		}
		inputBlue(key:string,val: string, index: number,id: string){
			this.list[index][key].dblStatus = false;
			this.$emit('editCel', {key, val,id});
		}
		// 合计
		getSummaries(param:any) {
			const { columns, data } = param;
			const sums:any[] = [];
			columns.forEach((column:any, index:number) => {
				if (index === 0) {
					sums[index] = '合计';
					return;
				}
				const values = data.map((item:any) => Number(item[column.property].value));
				if (!values.every((value:any) => isNaN(value))) {
					sums[index] = values.reduce((prev:any, curr:any) => {
					const value = Number(curr);
					if (!isNaN(value)) {
						return prev + curr;
					} else {
						return prev;
					}
					}, 0);
					// sums[index] += '元';
				} else {
					sums[index] = '';
				}
			});
			return sums;
		}
	}
